import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import InfoTooltip from "../InfoTooltip";
import "./styles.scss";

/**
 * HomeCard Component - Base card for all homepage sections
 *
 * @param {string} title - Title shown in the top left of the card
 * @param {React.ReactNode} info - Explanation in an info icon after the title
 * @param {boolean} viewMore - Show a "View more" link in the top right
 * @param {string} viewMoreLink - Route the "View more" link navigates to
 * @param {string} className - Extra class names for the card
 * @param {React.ReactNode} extra - Content in the top right of the card, e.g. a count
 * @param {React.ReactNode} children - Card content
 */
const HomeCard = ({
  title,
  info,
  viewMore = false,
  viewMoreLink = "",
  className = "",
  extra,
  children,
}) => {
  return (
    <div className={`home-card ${className}`.trim()}>
      {(title || viewMore || extra) && (
        <div className="home-card-header">
          {title && (
            <h3 className="home-card-title">
              {title}
              {info && <InfoTooltip text={info} />}
            </h3>
          )}
          {extra}
          {viewMore && viewMoreLink && (
            <Link to={viewMoreLink} className="home-card-view-more">
              View more <ArrowRightOutlined className="home-card-view-more-icon" />
            </Link>
          )}
        </div>
      )}

      <div className="home-card-body">{children}</div>
    </div>
  );
};

export default HomeCard;
